// Importing the GitHub and LinkedIn icons from Material UI, and the about object from the portfolio file
import GitHubIcon from '@material-ui/icons/GitHub'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import { about } from '../../portfolio'
import './About.css'

// Defining the About component
const About = () => {
  // Destructuring the properties of the about object
  const {photo,name, role, description, resume, social } = about

  // Rendering the component
  return (
    <div className='about center'>
      {/* If a photo is available, render it with a maximum height of 200 pixels */}
      {photo && (
       <img height="200px" alt="Avatar placeholder" src={photo} />
      )}
      {name && (
        <h1>
          <span className='about__name'>{name}</span>
        </h1>
      )}

{role && <h2 className='about__role'>{role}</h2>}
      <p className='about__desc'>{description && description}</p>

      <div className='about__contact center'>
        {resume && (
          <a href={resume}>
            <span type='button' className='btn btn--outline'>
              Resume
            </span>
          </a>
        )}

        {social && (
          <>
            {social.github && (
              <a
                href={social.github}
                aria-label='github'
                className='link link--icon'
              >
                <GitHubIcon />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                aria-label='linkedin'
                className='link link--icon'
              >
                <LinkedInIcon />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default About